<template>
  <div class="contents oshirase-list-container">
    <h2>お知らせ一覧</h2>
    <div class="menu" v-if="authStore.hasPermission(PermissionConst.RENRAKU_SEARCH_VIEW)">
      <p><router-link :to="{name: RouterConst.RENRAKU_SEARCH}">会社連絡の検索＞</router-link></p>
    </div>
    <loading v-if="isLoading" :message="'読み込み中...'"></loading>
    <div class="oshirase-list" v-if="!isLoading">
      <template v-if="OshiraseList.length > 0" v-for="oshirase in OshiraseList" :key="oshirase.oshirase_id">
        <oshirase-item :oshirase="oshirase" v-on:destroy="destroy(oshirase)"></oshirase-item>
      </template>

      <p class="align-center" v-else>{{ Message.EMPTY_OSHIRASE }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { useInit } from '@/composable/oshirase/init';
import { defineComponent, onMounted } from 'vue'
import oshiraseItem from '@/components/oshirase/Item.vue'
import { useOshiraseList } from '@/composable/oshirase/list';
import Message from '@/const/Message';
import { RouterConst } from '@/const/Router';
import { useAuthStore } from '@/store/auth';
import { PermissionConst } from '@/const/Permission';

export default defineComponent({
  setup() {
    const { OshiraseList } = useInit();
    const { destroy, getOshiraseList, isLoading } = useOshiraseList(OshiraseList);
    const authStore = useAuthStore()

    onMounted(async () => {
      await getOshiraseList();
    })
    
    return {
      authStore,
      PermissionConst,
      OshiraseList,
      destroy,
      isLoading,
      Message,
      RouterConst
    }
  },
  components: {
    'oshirase-item': oshiraseItem
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/oshirase-list.scss';
</style>
